import React from "react";

const LOGO_SRC = `${process.env.PUBLIC_URL}/oori-logo.svg`;

const VARIANT_CLASS = {
  // Keep logo height on mobile; avoid rigid min-width so Android narrow screens don't clip the cart.
  wordmark: "h-24 lg:h-28 w-auto max-w-[min(46vw,12.5rem)] sm:max-w-none sm:min-w-[14.25rem] lg:min-w-[18rem]",
  stacked: "h-16 sm:h-20 lg:h-24 w-auto max-w-[min(100%,320px)]",
  mark: "h-8 w-auto",
};

/**
 * Oori Label logo — SVG wordmark from /oori-logo.svg
 */
const Logo = ({
  variant = "wordmark",
  tagline = false,
  className = "",
  "data-testid": dataTestId,
}) => {
  const imgClass = `${VARIANT_CLASS[variant] || VARIANT_CLASS.wordmark} object-contain select-none block ${className}`;

  if (variant === "stacked" && tagline) {
    return (
      <div
        className={`inline-flex flex-col items-center text-center select-none ${className}`}
        data-testid={dataTestId || "logo-stacked"}
      >
        <img src={LOGO_SRC} alt="Oori Label" className={imgClass} />
        <span className="serif italic text-sm sm:text-base mt-5 opacity-75 max-w-xs leading-snug">
          Refined by Simplicity.
        </span>
      </div>
    );
  }

  return (
    <img
      src={LOGO_SRC}
      alt="Oori Label"
      className={imgClass}
      data-testid={dataTestId || `logo-${variant}`}
    />
  );
};

export default Logo;

